import {useMutation, useQueryClient} from '@tanstack/react-query';
import {
  restoreContentSubmissionsCache,
  updateVersionApprovalsInCache,
} from '@/utils/cache-updaters/contentSubmissions';
import contentSubmissionUpdaters from '@/api/updaters/contentSubmission';
import {CONTENT_SUBMISSION_QUERY_KEY} from '@/hooks/queries/use-content-submission-query';

function useCreateContentSubmissionApprovalsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: contentSubmissionUpdaters.createApprovals,
    onMutate: ({contentSubmissionId, contentSubmissionVersionId, steps}) => {
      const snapshots = updateVersionApprovalsInCache(
        contentSubmissionId,
        contentSubmissionVersionId,
        steps
      );
      return {snapshots};
    },
    onError: (_err, _vars, context) => {
      if (context?.snapshots) {
        restoreContentSubmissionsCache(context.snapshots);
      }
    },
    onSettled: (_data, _err, {contentSubmissionId}) => {
      queryClient.invalidateQueries({
        queryKey: [CONTENT_SUBMISSION_QUERY_KEY, contentSubmissionId],
      });
    },
  });
}

export default useCreateContentSubmissionApprovalsMutation;
